export default __webpack_public_path__ + "static/media/wooli.36960d83.png";